var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.9999 50H57.9999M41.9999 60.6667H57.9999M63.3333 74H36.6666C33.7211 74 31.3333 71.6122 31.3333 68.6667V31.3333C31.3333 28.3878 33.7211 26 36.6666 26H51.562C52.2693 26 52.9475 26.281 53.4476 26.781L67.8855 41.219C68.3856 41.719 68.6666 42.3973 68.6666 43.1046V68.6667C68.6666 71.6122 66.2788 74 63.3333 74Z",
    stroke: "#98A2B3",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.76fa8270de01d2aa2333959209a27e29.svg";
export { ForwardRef as ReactComponent };